import { ReactNode, useEffect } from 'react';
import { Overlay } from '../Overlay/Overlay';
import './Modal.css';

type ModalProps = {
	className?: string;
	show: boolean;
	onDismiss: () => void;
	children: ReactNode;
	toggle?: () => void;
	disableBodyScroll?: boolean;
};

const useDisableBodyScroll = (open: boolean) => {
	useEffect(() => {
		if (!open) return;
		// hold the width the scrollbar took, the way ScrollPreventer does, so hiding it does not
		// shift the page sideways
		const { clientWidth } = document.body;
		const { overflowY, width } = document.body.style;
		document.body.style.width = `${clientWidth}px`;
		document.body.style.overflowY = 'hidden';
		// lift the lock on unmount as well, or leaving the page with the modal open leaves the
		// next one unscrollable - and put back what was there rather than a fixed value, since
		// ScrollPreventer may hold a lock of its own that outlives this modal
		return () => {
			document.body.style.overflowY = overflowY;
			document.body.style.width = width;
		};
	}, [open]);
};

export const Modal = ({
	className = '',
	show,
	onDismiss,
	children,
	toggle,
	disableBodyScroll,
}: ModalProps): JSX.Element => {
	if (disableBodyScroll) {
		useDisableBodyScroll(show);
	}
	if (!show) return <></>;

	return (
		<>
			<Overlay onClick={onDismiss} toggle={toggle} />
			<div className={`modal ${className}`}>{children}</div>
		</>
	);
};
